<template>
    <va-create-layout>
        <product-form :title="title" :item="item"></product-form>
    </va-create-layout>
</template>

<script>
export default {
    props: ["title", "item"]
};
</script>
